import Header from "../../components/Header/Header";
import "./index.scss";
import { useLocation, useNavigate, Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { IS_MOBILE } from "@/utils/tool";
import { Alert, Form, Input, message } from "antd";
import Footer from "@/components/Footer";
import {
  fetchRegistrationInfo,
  submitRegistrationInfo,
} from "../../api/registration";
import { Select } from "antd";
import useLanguage from "@/hooks/useLanguage";

const RegistrationForm = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const [pageTitle, setPageTile] = useState("");
  const { language } = useLanguage();
  const [journalNames, setJournalNames] = useState([]);
  const [messageApi, contextHolder] = message.useMessage();

  useEffect(() => {
    const userInfo = localStorage.getItem("user");
    const uid = location.search.slice(1).split("=")[1];
    if (userInfo) {
      // 登记单查询
      getRegistrationInfo(uid);
    } else {
      navigate(
        `/login?goto=${encodeURIComponent(
          location.pathname
        )}?uid=${encodeURIComponent(uid)}`
      );
    }
  }, [location.pathname]);

  const getRegistrationInfo = async (uid) => {
    const res = await fetchRegistrationInfo<{
      title: string;
      journal_names: string[];
    }>({ uid });
    if (res.data) {
      setPageTile(res.data.title);
      const journalNames = res.data.journal_names?.map((item) => ({
        label: item,
        value: item,
      }));
      setJournalNames(journalNames || []);
    }
  };
  const handleSubmit = () => {
    if (loading) return;
    setLoading(true);
    try {
      form
        .validateFields()
        .then(async (values) => {
          const res = await submitRegistrationInfo(values);
          const resultValues = {
            journalNames: values.journal_name,
            articleTitle: values.article_title,
          };
          if (res.code === 0) {
            messageApi.success(t("提交成功"), () => {
              navigate(
                `/registrationResult?registrationInfo= ${encodeURIComponent(
                  JSON.stringify(resultValues)
                )}`,
                {
                  state: {
                    status: "success",
                    title: t("提交成功"),
                  },
                }
              );
            });
          } else {
            messageApi.error(res.msg, () => {
              setLoading(false);
            });
          }
        })
        .catch((info) => {
          console.log("Validate Failed:", info);
          setLoading(false);
        });
    } catch (error) {}
  };

  return (
    <>
      {contextHolder}
      <section
        className={`registration-from-wrapper ${
          IS_MOBILE ? "mobile-registration-from-wrapper" : ""
        }`}
      >
        <Header></Header>
        <section className="content-wrapper">
          <section className="page-title">{pageTitle}</section>
          <section className="tips">
            <Alert
              message={t(
                "为确保您的文章顺利发表，请核实提交时提供的信息是否准确一致。"
              )}
              type="info"
              showIcon
            />
          </section>
          <Form
            layout={"vertical"}
            form={form}
            colon={false}
            className="registration-antd-form"
          >
            <Form.Item
              name="uid"
              style={{ display: "none" }}
              initialValue={location.search.slice(1)?.split("=")[1]}
            >
              <div></div>
            </Form.Item>
            <Form.Item
              label={<span className="title">{t("期刊名称")}</span>}
              name="journal_name"
              rules={[
                {
                  required: true,
                  message: `${t("期刊名称")}${language == "en" ? " " : ""}${t(
                    "不能为空"
                  )}`,
                },
              ]}
            >
              <Select
                placeholder={t("选择期刊")}
                options={journalNames}
              ></Select>
            </Form.Item>
            <Form.Item
              label={<span className="title">{t("文章标题")}</span>}
              name="article_title"
              rules={[
                {
                  required: true,
                  message: `${t("文章标题")}${language == "en" ? " " : ""}${t(
                    "不能为空"
                  )}`,
                },
              ]}
            >
              <Input placeholder={t("输入文章标题")} maxLength={2000} />
            </Form.Item>
            <Form.Item
              label={<span className="author-title">{t("作者信息")}</span>}
            >
              <section className="authors-wrapper">
                <section className="first-author common">
                  <div className="title">{t("第一作者")}</div>
                  <Form.Item
                    label={<span className="sub-title">{t("名称")}</span>}
                    name="first_author_name"
                    rules={[
                      {
                        required: true,
                        message: `${t("第一作者")}${
                          language == "en" ? " " : ""
                        }${t("名称")}${language == "en" ? " " : ""}${t(
                          "不能为空"
                        )}`,
                      },
                    ]}
                  >
                    <Input placeholder={t("输入名称")} maxLength={2000} />
                  </Form.Item>
                  <Form.Item
                    label={<span className="sub-title">{t("组织")}</span>}
                    name="first_author_organization"
                    rules={[
                      {
                        required: true,
                        message: `${t("第一作者")}${
                          language == "en" ? " " : ""
                        }${t("组织")}${language == "en" ? " " : ""}${t(
                          "不能为空"
                        )}`,
                      },
                    ]}
                  >
                    <Input placeholder={t("输入组织")} maxLength={2000} />
                  </Form.Item>
                  <Form.Item
                    label={<span className="sub-title">{t("邮箱")}</span>}
                    name="first_author_email"
                    rules={[
                      {
                        required: true,
                        message: `${t("第一作者")}${
                          language == "en" ? " " : ""
                        }${t("邮箱")}${language == "en" ? " " : ""}${t(
                          "不能为空"
                        )}`,
                      },
                      {
                        type: "email",
                        message: `${t("邮箱")}${language == "en" ? " " : ""}${t(
                          "格式不对"
                        )}`,
                      },
                    ]}
                  >
                    <Input placeholder={t("输入邮箱")} maxLength={64} />
                  </Form.Item>
                </section>
                <section className="corresponding-author common">
                  <div className="title">{t("通讯作者")}</div>
                  <Form.Item
                    label={<span className="sub-title">{t("名称")}</span>}
                    name="corresponding_author_name"
                    rules={[
                      {
                        required: true,
                        message: `${t("通讯作者")}${
                          language == "en" ? " " : ""
                        }${t("名称")}${language == "en" ? " " : ""}${t(
                          "不能为空"
                        )}`,
                      },
                    ]}
                  >
                    <Input placeholder={t("输入名称")} maxLength={2000} />
                  </Form.Item>
                  <Form.Item
                    label={<span className="sub-title">{t("组织")}</span>}
                    name="corresponding_author_organization"
                    rules={[
                      {
                        required: true,
                        message: `${t("通讯作者")}${
                          language == "en" ? " " : ""
                        }${t("组织")}${language == "en" ? " " : ""}${t(
                          "不能为空"
                        )}`,
                      },
                    ]}
                  >
                    <Input placeholder={t("输入组织")} maxLength={2000} />
                  </Form.Item>
                  <Form.Item
                    label={<span className="sub-title">{t("邮箱")}</span>}
                    name="corresponding_author_email"
                    rules={[
                      {
                        required: true,
                        message: `${t("通讯作者")}${
                          language == "en" ? " " : ""
                        }${t("邮箱")}${language == "en" ? " " : ""}${t(
                          "不能为空"
                        )}`,
                      },
                      {
                        type: "email",
                        message: `${t("电子邮箱")}${
                          language == "en" ? " " : ""
                        }${t("格式不对")}`,
                      },
                    ]}
                  >
                    <Input placeholder={t("输入邮箱")} maxLength={64} />
                  </Form.Item>
                </section>
              </section>
            </Form.Item>
          </Form>
          <section
            className="button-wrapper"
            style={IS_MOBILE ? { paddingBottom: 30 } : {}}
          >
            <button onClick={handleSubmit} disabled={loading}>
              {t("提交")}
            </button>
          </section>
        </section>
        {!IS_MOBILE && <Footer></Footer>}
      </section>
    </>
  );
};

export default RegistrationForm;
